module.exports = __webpack_public_path__ + "b2728ab4cbd817a5bba677afb5a7a68f.png";